import { Participant } from "./Participant";

export class UserParticipant extends Participant {
    performerId: string;
    performerName: string;
    performerCode?: string;
    orgId?: string;
    orgName?: string;
    orgType?: string;
    tag?: string;
}
